<template>
  <div class="SpTableColumn" />
</template>

<script type="text/ecmascript-6">
import { getObjectValue, isArray, isObject } from '@/utils'

export default {
  name: 'SpTableColumn',

  nameSpace: 'SpTableColumn',

  inject: ['SpTable'],
  props: {
    columnName: {
      type: String,
      default: ''
    },

    label: {
      type: String,
      default: ''
    },

    width: {
      type: Number,
      default: 0
    },

    fixed: {
      type: [Boolean, String],
      default: false
    },

    ellipsis: {
      type: Boolean,
      default: true
    },
    cusClass: {
      type: String,
      default: ''
    }
  },

  computed: {
    contentProp () {
      return { class: 'ellipsis text-center', style: { width: this.width !== 0 ? `${this.width}px` : 'auto' } }
    },

    table () {
      return this.SpTable.value || this.SpTable
    }
  },

  unmounted () {
    console.log('unmount table column')
  },

  created () {
    if (this.getColumnIndex(this.table.columns, this.label || this.columnName) < 0) {
      this.table.columns.push({
        columnName: this.columnName,
        label: this.label || this.columnName,
        width: this.width,
        fixed: this.fixed,
        class: this.cusClass,
        ellipsis: this.ellipsis,
        slot: !!this.$slots.default,
        header: this.$slots.header ? (h) => { return this.$slots.header() } : null,
        render: (h, data, $index) => {
          data = isObject(data) ? data : { data }
          data.$index = $index
          return this.$slots.default ? this.$slots.default(data) : getObjectValue(data, this.columnName) || '-'
        }
      })
    } else {
      const old = this.table.columns[this.getColumnIndex(this.table.columns, this.label || this.columnName)]
      this.table.columns.splice(this.getColumnIndex(this.table.columns, this.label || this.columnName), 1, {
        columnName: this.columnName,
        label: this.label || this.columnName,
        width: [old.width, this.width],
        slot: [old.slot, !!this.$slots.default],
        ellipsis: [old.ellipsis, this.ellipsis],
        fixed: [old.fixed, this.fixed],
        header: this.$slots.header ? (h) => { return this.$slots.header() } : old.header,
        render: [old.render, (h, data, $index) => {
          data = isObject(data) ? data : { data }
          data.$index = $index
          return this.$slots.default ? this.$slots.default(data) : getObjectValue(data, this.columnName) || '-'
        }]
      })
    }
  },

  beforeUnmount () {
    const columnIndex = this.getColumnIndex(this.table.columns, this.label || this.columnName)
    if (columnIndex > -1) {
      this.table.columns.splice(columnIndex, 1)
    }
  },

  methods: {
    getColumnIndex (columns, columnName) {
      return columns.findIndex((c) => { return c.label === columnName })
    }
  }
}
</script>

<style scoped lang="less">
.SpTableColumn{
//css、less
}
</style>
